import * as React from "react";
import { isQueueUrlValid, isRequestDataValid } from "../models/Premise";
import { BoldSpan, Button, RightDiv, Separator, StandardDiv, Table } from "@atlassiansox/microscopekit";
import EditFilledIcon from "@atlaskit/icon/glyph/edit-filled";
import TrashIcon from "@atlaskit/icon/glyph/trash";
import { PremiseType } from "../../__generated__/graphql-global-types";
export var PremiseDetailView = function (props) {
    var _a;
    var tableRows = [];
    tableRows.push([
        "Provider",
        props.premise.provider ? props.premise.provider : ""
    ]);
    tableRows.push(["PremiseType", props.premise.inputType]);
    var premiseInputType = props.premise.inputType;
    var premiseInputData = props.premise.inputData;
    var isQueueUrlVisible = isQueueUrlValid(premiseInputType);
    var isRequestDataVisible = isRequestDataValid(props.premise);
    var additionalParams = [];
    additionalParams.push(["No. of Users", premiseInputData.user_count]);
    additionalParams.push(["Ramp up Time", premiseInputData.ramp_up_time]);
    additionalParams.push([
        "Steady state Time",
        premiseInputData.steady_state_time
    ]);
    return (React.createElement("div", null,
        props.editForm != null ? (React.createElement(RightDiv, null,
            React.createElement(Button, { appearance: "primary", iconBefore: React.createElement(EditFilledIcon, { label: "edit" }), onClick: function (event) {
                    if (props.editForm != null) {
                        props.editForm();
                    }
                } }, "Edit"),
            React.createElement(Separator, null),
            React.createElement(Button, { iconBefore: React.createElement(TrashIcon, { label: "delete" }), onClick: function () {
                    if (props.onDelete) {
                        props.onDelete();
                    }
                } }, "Delete"))) : (""),
        React.createElement(Table, { title: "Premise", cells: tableRows }),
        React.createElement(Separator, null),
        React.createElement("div", { hidden: props.premise.inputType !== PremiseType.perfhammer_scripts },
            React.createElement("div", null,
                React.createElement(BoldSpan, null, "Repo"),
                ":",
                React.createElement(StandardDiv, null, premiseInputData.repo)),
            React.createElement("div", null,
                React.createElement(BoldSpan, null, "Branch"),
                ":",
                React.createElement(StandardDiv, null, premiseInputData.branch)),
            React.createElement("div", null,
                React.createElement(BoldSpan, null, "Script"),
                ":",
                React.createElement(StandardDiv, null, premiseInputData.script_name))),
        React.createElement("div", { hidden: props.premise.inputType !== PremiseType.perfhammer_apis },
            React.createElement("div", null,
                React.createElement(BoldSpan, null, "Request Method"),
                ":",
                React.createElement(StandardDiv, null, premiseInputData.request_method)),
            React.createElement("br", null),
            React.createElement("div", null,
                React.createElement(BoldSpan, null, "APIs"),
                ":",
                React.createElement("ul", null, (_a = premiseInputData.apis) === null || _a === void 0 ? void 0 : _a.split(",").map(function (value) { return (React.createElement("li", null, value)); })))),
        isQueueUrlVisible && (React.createElement("div", null,
            React.createElement(BoldSpan, null, "Queue URL"),
            ":",
            React.createElement(StandardDiv, null, premiseInputData.queue_url))),
        isRequestDataVisible && (React.createElement(React.Fragment, null,
            React.createElement("h4", null, "Request Data"),
            React.createElement("pre", null, JSON.stringify(premiseInputData.request_data, null, 2)))),
        React.createElement(Separator, null),
        React.createElement(Table, { cells: additionalParams, title: "Advanced Options", emptyMessage: "No Parameters added" }),
        React.createElement(Separator, null),
        premiseInputData.custom_env_variables && (React.createElement("div", null,
            React.createElement("h4", null, "Custom Environment Variables"),
            React.createElement("pre", null, JSON.stringify(premiseInputData.custom_env_variables, null, 2))))));
};
